import React from "react";
import Italian from "app/translations/it.json";
import Urdu from "app/translations/ur.json";
import English from "app/translations/en.json";
import Deutch from "app/translations/de.json";
import Greek from "app/translations/el.json";
import Spanish from "app/translations/es.json";
import styled from "styled-components";
import "url-search-params-polyfill";

import en from "date-fns/locale/en";
import it from "date-fns/locale/it";
import de from "date-fns/locale/de";
import el from "date-fns/locale/el";
import es from "date-fns/locale/es";

export { compose } from "redux";

function* idGenerator() {
  var counter = 0;
  while (true) {
    yield "localId" + counter++;
  }
}

export const ids = idGenerator();
export const next = g => g.next().value;

export const asyncActionType = type => ({
  toString: () => type,
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`
});

export const createHocBase = Component =>
  class extends React.Component {
    render() {
      return <Component {...this.props} {...this.state} />;
    }
  };

export const capitalizeFirstLetter = string => {
  if (typeof string !== "string") return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getLocale = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has("locale") ? urlParams.get("locale") : navigator.language;
};

export const getURLSearch = () => window.location.search;

export const messages = {
  it: Italian,
  "en-GB": English,
  ur: Urdu,
  de: Deutch,
  el: Greek,
  es: Spanish
};

export const dateLocale = {
  it: it,
  "en-GB": en,
  de: de,
  ur: en,
  el: el,
  es: es
};

export const Header = styled.h1`
  padding-bottom: 20px;
  border-bottom: solid 1px #a0a0a0;
`;



// WEBPACK FOOTER //
// ./src/app/utils.js